<section class="access-controls" aria-labelledby="page-title">
  <nav class="breadcrumb flex align-center gap-8 fs-12 mb-15" aria-label="Breadcrumb">
    <a class="breadcrumb__link fw-600" routerLink="/" aria-label="Return to the dashboard"
      >Dashboard</a
    >
    <app-icon
      class="breadcrumb__icon"
      name="chevron_right"
      size="xs"
      color="custom"
      customColor="currentColor"
      role="presentation"
    ></app-icon>
    <span aria-current="page">Access &amp; Controls</span>
  </nav>

  <header class="page-header mb-20">
    <h1 id="page-title" class="page-title fs-22 fw-700 m-0">Access &amp; Controls</h1>
    <p class="page-subtitle m-0 mt-5">
      Manage patient portal access and employee account permissions.
    </p>
  </header>

  <ul class="access-grid" aria-label="Access and controls areas">
    @for (area of areas; track area.id) {
    <li>
      <!-- The chips are metadata about the area, not part of the action's name, so the button is
           named by its title alone and described by the sentence under it plus the chip band —
           AC3 lists the tags as card content, so they have to reach assistive tech somehow. -->
      <button
        type="button"
        class="access-card"
        [id]="'access-card-' + area.id"
        [attr.aria-label]="area.title"
        [attr.aria-describedby]="
          'access-card-desc-' + area.id + ' access-card-caps-' + area.id
        "
        aria-haspopup="dialog"
        (click)="openArea(area, $event.currentTarget)"
      >
        <span class="access-card__header">
          <span class="access-card__icon" aria-hidden="true">
            <app-icon [name]="area.icon" size="custom" customSize="26px" color="primary" />
          </span>

          <span class="access-card__text">
            <span class="access-card__title">{{ area.title }}</span>
            <span class="access-card__description" [id]="'access-card-desc-' + area.id"
              >{{ area.description }}</span
            >
          </span>

          <app-icon
            class="access-card__chevron"
            name="chevron_right"
            size="sm"
            color="custom"
            customColor="currentColor"
            role="presentation"
          />
        </span>

        <span class="access-card__capabilities" [id]="'access-card-caps-' + area.id">
          @for (capability of area.capabilities; track capability.label) {
          <span class="badge capability-chip--{{ capability.tone }}">{{ capability.label }}</span>
          }
        </span>
      </button>
    </li>
    }
  </ul>
</section>

@if (activeArea()) {
<div class="modal-backdrop" role="presentation" (click)="closeModal()">
  <!-- `stopPropagation` keeps a click inside the dialog from reaching the scrim's close handler.
       `cleared` is deliberately not bound: the dialog owns its own field state and this page
       passes no `initialFilter`, so there is nothing here to undo. -->
  <app-patient-search-modal
    subtitle="Enter details to find a patient and manage their portal access."
    [minimumCriteria]="minimumCriteria"
    (applied)="onPatientSearch($event)"
    (closed)="closeModal()"
    (click)="$event.stopPropagation()"
  ></app-patient-search-modal>
</div>
}
